"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const media_1 = require("./media");
class MediaGroup extends index_1.TopLevelNode {
    constructor() {
        super(...arguments);
        this.content = new index_1.ContentNode('mediaGroup');
    }
    media(attrs) {
        this.content.add(new media_1.Media(attrs));
        return this;
    }
    link(id, collection) {
        this.content.add(new media_1.Media({ id, collection, type: 'link' }));
        return this;
    }
    file(id, collection) {
        this.content.add(new media_1.Media({ id, collection, type: 'file' }));
        return this;
    }
    toJSON() {
        return this.content.toJSON();
    }
}
exports.MediaGroup = MediaGroup;
//# sourceMappingURL=media-group.js.map